import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@robinpowered/ui-kit';
import { useTranslation } from 'react-i18next';
export var SpaceOrganizerLabel = function () {
    var t = useTranslation('meetingRooms').t;
    return (_jsx(Typography.Text, { type: "secondary", size: "small", style: { whiteSpace: 'nowrap' }, children: t('spaces.organizer') }));
};
